import React, {  useEffect, useState } from "react";

// import {
//   FormWrapper,
//   FormInput,
//   FormLabel,
//   FormInputRow,
//   FormMessage,
//   Button,
//   FormTitle,
// } from "../StyledComp/StyledComp";
// import { useDispatch } from "react-redux";
// import {
//   updateMember_Sections,
//   updateMember_Tags,
// } from "../../store/memberApiSlice";
interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
}

interface IProps {
  section: ISection;
  isActive: boolean;
  isLastYear: boolean;
  selectedSections: (Number | null)[];
  onChangeFunction: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: ISection
  ) => void;
}

const OrderEditSectionMultipleOptionItems: React.FC<IProps> = (props) => {
  // const dispatch = useDispatch();
  const [section, setSection] = useState(props.section);
  const [isSelected, setISSelected] = useState(section.isSelected);
  //   props.isActive ? false : props.section.isSelected
  // props.isActive
  //   ? false
  //   : props.selectedSections?.includes(section.Id)
  //   ? true
  //   : false
  // );

  useEffect(() => {
    console.log("props.selectedSections:", props.selectedSections);
  }, []);
  const handleChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    SectionName: string
  ) => {
    console.log("sections in handleChecked1:", section);
    setISSelected(!isSelected);
    console.log("OrderEditSectionMultipleOptionItems-section:", section);
    const updatedSection = { ...section, isSelected: !section.isSelected };
    setSection(updatedSection);
    props.onChangeFunction(event, updatedSection);
  };

  return (
    <>
      <div key={section.Id} className="order-checkboxgroup" style={{ width: "40%" }}>
        <input
          id={String(section.Id)}
          className="checkbox"
          type="checkbox"
          checked={isSelected && !props.isActive}
          disabled={props.isActive}
          onChange={(event) => handleChecked(event, section.SectionName)}
        />
        <div>
          <span style={{ marginRight: "5px" }}>
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(section.Fee as number)}
          </span>
          <span> {section.SectionName}</span>
          <span style={{ marginLeft: "5px", color: "#03c04A" }}>
            {props.isActive ? (
              "(Active)"
            ) : props.isLastYear ? (
              "(Last year)"
            ) : (
              <></>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default OrderEditSectionMultipleOptionItems;
